import { getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table';
import { useVirtualizer } from '@tanstack/react-virtual';
import React from 'react';

import { TUseDataTableProps } from './types';

export function useDataTable<TData, TValue>({
  data = [],
  columns,
  fetchMoreOnBottomReached,
}: TUseDataTableProps<TData, TValue>) {
  const containerRef = React.useRef<HTMLDivElement>(null);

  const table = useReactTable({
    data,
    columns,
    manualSorting: true,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  const rows = table.getRowModel().rows;

  const rowVirtualizer = useVirtualizer({
    count: rows.length,
    estimateSize: React.useCallback(() => 1, []),
    getScrollElement: () => containerRef.current,
  });

  const onScroll = React.useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      fetchMoreOnBottomReached?.(e.currentTarget);
    },
    [fetchMoreOnBottomReached]
  );

  return {
    table,
    rows,
    rowVirtualizer,
    containerRef,
    onScroll,
  };
}
